import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import { useState } from 'react';
import { getMultilineFormattedAddress } from '../../../../../../../../models/UiUtils';
import { THEME } from '../../../../../../../components-v2/Theme/theme';
import { Button } from '../../../../../../../components/Button';
import { UpdateAddressModal } from '../../../../../../../components/entities/UpdateAddressModal';
import { EditItemPenIcon } from '../../../../../../../components/svgs/icons/EditItemPenIcon';
import { LocationIcon } from '../../../../../../../components/svgs/icons/LocationIcon';
import { styleSheet } from '../../styles';

interface AddressProps {
	contact: Api.IContact;
	onAddressChanged: (address: Api.IAddress) => void;
}

export const Address = ({ contact, onAddressChanged }: AddressProps) => {
	const [isEditing, setIsEditing] = useState(false);

	const { address } = contact;
	const formattedAddress = getMultilineFormattedAddress(address ?? {});
	const hasAtleastPartialAddress = !!formattedAddress;

	const handleClickToSaveAddress = (newAddress: Api.IAddress) => {
		onAddressChanged(newAddress);
		setIsEditing(false);
	};

	return (
		<div className={css(styleSheet.addressCard)}>
			<div>
				<LocationIcon fill={THEME.colors.border.main} height={24} width={14} />
			</div>
			<div className={css(styleSheet.addressCardContent)}>
				{hasAtleastPartialAddress ? (
					<div className={css(styleSheet.contactDetailAddressDisplay)}>
						<div className={css(styleSheet.addressContent)}>{formattedAddress}</div>
						<div className={`${css(styleSheet.addressActions)} actions`}>
							<Button kind='icon' onClick={() => setIsEditing(true)}>
								<EditItemPenIcon />
							</Button>
						</div>
					</div>
				) : (
					<div className={css(styleSheet.contactDetailAddressAddButton)}>
						<Button kind='link' onClick={() => setIsEditing(true)}>
							+ Add Address
						</Button>
					</div>
				)}
			</div>

			<UpdateAddressModal
				initAddress={address}
				onClickToSave={handleClickToSaveAddress}
				modalProps={{
					isOpen: isEditing,
					onRequestClose: () => setIsEditing(false),
				}}
			/>
		</div>
	);
};
